<template>
  <div id="base-editor-page" class="mt-20">
    <div class="panel panel-default">
      <div class="panel-body">
        <OverviewContainer />
        <VersionContainer
          v-for="project in authorProjects"
          :key="project.versionKey"
          :versionData="project"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState, mapActions } from 'vuex';
  import VersionContainer from './VersionContainer';
  import OverviewContainer from './OverviewContainer';
  export default {
    name: 'Results',
    created() {
      // this.getAllVersions();
      this.getAuthorProjects();
    },

    data() {
      return {};
    },
    components: {
      VersionContainer,
      OverviewContainer,
    },

    async mounted() {},

    methods: {
      ...mapActions('versions', [
        'getAllVersions',
        'getAllRecentProjects',
        'getAllFeaturedProjects',
        'getAuthorProjects',
      ]),
    },

    computed: {
      ...mapState('versions', ['authorProjects']),
    },
  };
</script>
<style lang="scss" scoped></style>
